export default __webpack_public_path__ + "static/media/1.ab4f6030.png";